export const ORIGIN_BACKEND_HEADER = 'x-api-origin-backend';
